import { FC } from "react";

type SectionTitleProps = {
    name: string;
};

export const SectionTitle: FC<SectionTitleProps> = ({ name }) => {
    return <h1 className="main-title">{name}</h1>
};